import script from "./UiCopyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UiCopyButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__